import store from "@/plugins/store";
import { RouteLocationRaw } from "vue-router";

export default function notLoggedIn(): RouteLocationRaw | void {
  if (store.getters["user/isLoggedIn"]) {
    return { name: "Feed" };
  }
}
